module.exports = __webpack_public_path__ + "img/fl_big.3aa04078.png";